<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>

                            <div class="modal-header row" style="justify-content: flex-end;">
                                <div class="col">
                                    <button type="button" class="close" @click="$emit('closeModal')">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>

                            <div class="modal-body">
                                <h2 class="title">{{ isNew ? 'New' : 'Edit' }} Vehicle Type</h2>
                                <form>
                                    <div class="row row-space">
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Name<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.name"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Name"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Commercial Name<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.commercial_name"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Commercial Name"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Material Group Description<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.material_group_desc"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Material Group Description"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Manufacture Year<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.manufacture_year"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Manufacture Year"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Category<span style="color: red;">*</span></label>
                                                <MultiSelect
                                                    v-model="form.category"
                                                    :options="options.category.map(x => x.category)"
                                                    placeholder="Choose Category"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Segment<span style="color: red;">*</span></label>
                                                <MultiSelect
                                                    v-model="form.segment"
                                                    :options="options.segment.map(x => x.segment)"
                                                    :disabled="form.category == null || form.category == ''"
                                                    placeholder="Choose Segment"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Sub Series<span style="color: red;">*</span></label>
                                                <MultiSelect
                                                    v-model="form.subSeries"
                                                    :options="options.subSeries.map(x => x.subSeries)"
                                                    :disabled="form.segment == null || form.segment == ''"
                                                    placeholder="Choose Sub Series"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Type<span style="color: red;">*</span></label>
                                                <MultiSelect
                                                    v-model="form.type"
                                                    :options="options.type.map(x => x.type)"
                                                    :disabled="form.subSeries == null || form.subSeries == ''"
                                                    placeholder="Choose Type"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Sub Type<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.sub_tipe"
                                                    type="text"
                                                    class="input--style-4"
                                                    placeholder="Type Sub Type"
                                                >
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <label class="label">Code<span style="color: red;">*</span></label>
                                                <input
                                                    v-model="form.code"
                                                    type="text"
                                                    class="input--style-4"
                                                    :disabled="!isNew"
                                                    placeholder="Type Code"
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col mt-5" style="text-align: center">
                                            <button type="button" class="btn btn-outline-danger" style="font-size:140%"
                                                @click="$emit('closeModal')">Cancel</button>
                                            <button type="button" class="btn btn-primary ml-5" style="font-size:150%"
                                                @click="submitForm()">{{ isNew ? 'Create' : 'Edit' }}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            </div>
        </div>
    </transition>
</template>

<script>
    import MultiSelect from 'vue-multiselect';

    export default {
        data() {
            let user = this.$store.getters.currentUser

            return {
                dataReady : false,
                mobile: this.isMobile(),
                isNew : true,
                options : {
                    category : this.$store.getters.getSimpleCategory,
                    segment : this.$store.getters.getSimpleSegment(),
                    subSeries : this.$store.getters.getSimpleSubSeries(),
                    type : this.$store.getters.getSimpleType()
                },
                form: {
                    name : '',
                    commercial_name : '',
                    material_group_desc : '',
                    manufacture_year : '',
                    category : '',
                    segment : '',
                    subSeries : '',
                    type : '',
                    sub_tipe : '',
                    code : '',
                },
            }
        },
        props : ['data'],
        components: {
            MultiSelect,
        },
        async mounted() {
            if (this.data) await this.convertEdit();
            setTimeout(()=>{this.dataReady = true}, 200);
        },
        watch: {
            'form.category' () {
                if(!this.dataReady) return;

                this.options.segment = this.$store.getters.getSimpleSegment(this.form.category);
                this.form.segment = '';

                this.options.subSeries = this.$store.getters.getSimpleSubSeries(this.form.category, this.form.segment);
                this.form.subSeries = '';

                this.options.type = this.$store.getters.getSimpleType(this.form.category, this.form.segment, this.form.subSeries);
                this.form.type = '';
            },
            'form.segment' () {
                if(!this.dataReady) return;

                this.options.subSeries = this.$store.getters.getSimpleSubSeries(this.form.category, this.form.segment);
                this.form.subSeries = '';

                this.options.type = this.$store.getters.getSimpleType(this.form.category, this.form.segment, this.form.subSeries);
                this.form.type = '';
            },
            'form.subSeries' () {
                if(!this.dataReady) return;

                this.options.type = this.$store.getters.getSimpleType(this.form.category, this.form.segment, this.form.subSeries);
                this.form.type = '';
            }
        },
        methods: {
            convertEdit() {
                this.isNew = false;

                this.form.name = this.data.name;
                this.form.commercial_name = this.data.commercial_name;
                this.form.material_group_desc = this.data.material_group_desc;
                this.form.manufacture_year = this.data.manufacture_year;
                this.form.category = this.data.category;
                this.form.segment = this.data.segment;
                this.form.subSeries = this.data.sub_series;
                this.form.type = this.data.type;
                this.form.sub_tipe = this.data.sub_type;
                this.form.code = this.data.code;
            },
            validateForm() {
                let errors = [];

                // Name
                if (!this.form.name) errors.push('<strong>Name</strong> is a required field!');

                // Commercial Name
                if (!this.form.commercial_name) errors.push('<strong>Commercial Name</strong> is a required field!');

                // Material Group Description
                if (!this.form.material_group_desc) errors.push('<strong>Material Group Description</strong> is a required field!');

                // Manufacture Year
                if (!this.form.manufacture_year) errors.push('<strong>Manufacture Year</strong> is a required field!');
                else if (isNaN(this.form.manufacture_year)) errors.push('<strong>Manufacture Year</strong> must be a number!');

                // Category
                if (!this.form.category) errors.push('<strong>Category</strong> is a required field!');

                // Segment
                if (!this.form.segment) errors.push('<strong>Segment</strong> is a required field!');

                // Sub Series
                if (!this.form.subSeries) errors.push('<strong>Sub</strong> Series is a required field!');

                // Type
                if (!this.form.type) errors.push('<strong>Type</strong> is a required field!');

                // Sub Type
                if (!this.form.sub_tipe) errors.push('<strong>Sub Type</strong> is a required field!');

                // Code
                if (!this.form.code) errors.push('<strong>Code</strong> is a required field!');

                if (errors.length > 0) {
                    this.$swal.fire({
                        title : "Error!",
                        icon : "error",
                        html : errors.join("<br>")
                    })
                    return false;
                } else 
                    return true;
            },
            async submitForm() {
                let vm = this;

                if (vm.validateForm()) {
                    let method = this.isNew ? 'post' : 'put';
                    let url = this.isNew ? '/api/setting/vehicle-type' : `/api/setting/vehicle-type/${this.form.code}`;
                    this.$http[method](url, this.form)
                    .then((resp) => {
                        // alert(`Partshop ${vm.form.name} has been created`);
                        this.$swal.fire({
                            title : "Success!",
                            icon : "success",
                            text : `${this.form.code} - ${this.form.name} has been successfully created`
                        })
                        this.loadFilterOptions('codeMarket');
                        this.$emit('refreshData');
                        this.$emit('closeModal');
                        // vm.$emit('triggerAlert', false, [`${this.form.code} - ${this.form.name} has been successfully created`]);
                    })
                    .catch((err) => {
                        console.log(err);
                        if (Array.isArray(err.response.data.data)) {
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                html : err.response.data.data.map(x=>x.message).join("<br>")
                            })
                        } else {
                            this.$swal.fire({
                                title : "Error!",
                                icon : "error",
                                text : err.response.data.data ? err.response.data.data : err.response.data.message
                            })
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body {
        margin: 0
    }

    .modal-body .moduleLine {
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a {
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover {
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox {
        border: 1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color: black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i {
        font-size: 5vh;
    }

    h3.modalHeadline {
        margin: 0 0 20px 0;
        font-weight: bold;
        text-align: center;
    }

    /* MODAL ENDS */

    /* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
    input {
        outline: none;
        margin: 0;
        border: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        width: 100%;
        font-size: 14px;
        font-family: inherit;
    }

    .input--style-4 {
        line-height: 50px;
        background: #fafafa;
        -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        padding: 0 20px;
        font-size: 16px;
        color: #666;
        -webkit-transition: all 0.4s ease;
        -o-transition: all 0.4s ease;
        -moz-transition: all 0.4s ease;
        transition: all 0.4s ease;
    }

    .input--style-4::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: #666;
    }

    .input--style-4:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #666;
        opacity: 1;
    }

    .input--style-4::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #666;
        opacity: 1;
    }

    .input--style-4:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #666;
    }

    .input--style-4:-ms-input-placeholder {
        /* Microsoft Edge */
        color: #666;
    }

    .label {
        font-size: 16px;
        color: #555;
        text-transform: capitalize;
        display: block;
        margin-bottom: 5px;
    }

    .radio-container {
        display: inline-block;
        position: relative;
        padding-left: 30px;
        cursor: pointer;
        font-size: 16px;
        color: #666;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .radio-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    .radio-container input:checked~.checkmark {
        background-color: #e5e5e5;
    }

    .radio-container input:checked~.checkmark:after {
        display: block;
    }

    .radio-container .checkmark:after {
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 12px;
        height: 12px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        background: #57b846;
    }

    .checkmark {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #e5e5e5;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .input-group {
        position: relative;
        /* margin-bottom: 22px; */
        padding: 20px;
    }

    .input-group-icon {
        position: relative;
    }

    .input-icon {
        position: absolute;
        font-size: 18px;
        color: #999;
        right: 18px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
        cursor: pointer;
    }

    /* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
    .title {
        font-size: 40px;
        color: #525252;
        margin-bottom: 40px;
        text-align: center;
    }




    .input--style-4:disabled {
        background: #cfcfcf;
    }

    .modal-body {
        max-height: 80vh;
        overflow-y: auto;
        overflow-x: auto;
    }

    .innerBox {
        padding: 0.8em 1.5em;
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        background-color: white;
        box-shadow: 2px 2px 5px #E0E0E0;
    }

    .hoverable:hover {
        cursor: pointer;
    }
</style>